<template>
  <div class="l-mainHeader__gMenuItem">
    <div
      class="text-decoration-none"
      :class="{ active: active }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderMenuItem',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.l-mainHeader__gMenuItem >>> div {
  cursor: pointer;
  margin-top: 10px;
  margin-left: 30px;
  line-height: 48px;
  display: block;
  color: #6d6d6d;
  padding: 0 8px;
}

.l-mainHeader__gMenuItem >>> span {
  font-size: 1rem;
  margin-left: 5px;
  line-height: 48px;
}

.l-mainHeader__gMenuItem >>> div.active {
  position: relative;
  display: block;
  color: #315ed9;
  font-weight: 500;
  box-sizing: border-box;
  border-bottom: 3px solid #315ed9;
}

.l-mainHeader__gMenuItem >>> .active .v-icon {
  color: #315ed9;
}
</style>
